import { AutoComplete, Form, Input, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCodigosInfraccionAPI, { CodigoInfraccion } from "../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import useEtiquetas from "../codigos-infraccion/hooks/useEtiquetas";
import DataSave from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import { ActionResult } from "../common/hooks/useApi";
import useConveniosPagoConfiguracionesAPI, { ConveniosPagoConfiguracion, ConveniosPagoConfiguracionForm, ConveniosPagoConfiguracionSave } from "./useConveniosPagoConfiguracionesAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";
import _ from 'lodash'

export default () => {
    const { id } = useParams();
    const api = useConveniosPagoConfiguracionesAPI();
    const configuracionesProduccionApi = useConfiguracionesProduccionAPI();

    const successRoute = "/convenios-pago/configuraciones"

    const [item, setItem] = useState<ConveniosPagoConfiguracion>()
    const [configuracionesProduccionResponse, setConfiguracionesProduccionResponse] = useState<ActionResult<ConfiguracionProduccion[]>>()

    const loadConfiguracionesProduccion = () => {
        configuracionesProduccionApi
            .list({ $top: 10000, $orderby: ["Nombre desc"], $select: ["Id,Nombre,UnidadProduccionId"], $expand: ["UnidadProduccion"] })
            .then(setConfiguracionesProduccionResponse)
    }

    useEffect(() => {
        loadConfiguracionesProduccion()
    }, [])

    return (
        <MainLayout title="Guardar configuración de convenio de pago">
            <DataSave<ConveniosPagoConfiguracion, ConveniosPagoConfiguracionSave, ConveniosPagoConfiguracionForm>
                list={(q) => api.list({ ...q, ...{ $expand: ["ConfiguracionesProduccion", "EPagos", "DescuentosPermitidos"] } })}
                save={api.save}
                onChange={(data) => {
                    setItem({
                        ...data,
                        ...{
                            ConfiguracionesProduccion: data.ConfiguracionesProduccion?.map(v => ({ Id: v })),
                            DescuentosPermitidos: data.DescuentosPermitidos?.map(v => ({ Porcentaje: v }))
                        }
                    })
                }}
                transformOnLoad={async (value) => (
                    {
                        ...value,
                        ...{
                            ConfiguracionesProduccion: value.ConfiguracionesProduccion.map(v => v.Id),
                            DescuentosPermitidos: value.DescuentosPermitidos.map(v => v.Porcentaje)
                        }
                    })}
                transformOnSave={async (value) => {
                    return {
                        ...value,
                        ...{
                            ConfiguracionesProduccion: JSON.stringify(value.ConfiguracionesProduccion.map(v => ({ Id: v }))),
                            DescuentosPermitidos: JSON.stringify(value.DescuentosPermitidos.map(v => ({ Porcentaje: v }))),
                        }
                    }
                }}
                id={id}
                successRoute={successRoute}

            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Nombre"}
                    label="Nombre">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"ConfiguracionesProduccion"}
                    label="Configuraciones de producción asociadas"

                >
                    <Select
                        optionFilterProp="children"
                        mode="multiple"
                        allowClear
                    >
                        {configuracionesProduccionResponse?.data?.value.map(c =>
                            <Select.Option key={c.Id} value={c.Id}>{c.Nombre} - {c.UnidadProduccion.Nombre}</Select.Option>)}
                    </Select>
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    label={"Template"}
                    name="Template">
                    <Input />
                </Form.Item>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    label={"Descuentos permitidos"}
                    name="DescuentosPermitidos">
                    <Select
                        mode="multiple"
                    >
                        {_.range(81)
                            .filter(i => i >= 0 && i % 5 == 0)
                            .map(i =>
                                <Select.Option value={i} key={i}>
                                    {i}%
                                </Select.Option>)}
                    </Select>
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    label={"Dias vencimiento"}
                    name="DiasVencimientoPago">
                    <Input />
                </Form.Item>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    label={"Plataforma de pago"}
                    name="PlataformaPago">
                    <Select>
                        <Select.Option value="EPAGOS">EPagos</Select.Option>
                    </Select>
                </Form.Item>

                {item?.PlataformaPago == 'EPAGOS' &&
                    <>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "UrlApi"]}
                            label="Url de la api">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "IdOrganismoEpagos"]}
                            label="Id del organismo">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "IdUsuarioEpagos"]}
                            label="Id del usuario">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "HashEpagos"]}
                            label="Hash">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "PasswordEpagos"]}
                            label="Password">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={["EPagos", "ConvenioEpagos"]}
                            label="Convenio">
                            <Input />
                        </Form.Item>
                        <Form.Item                        
                        rules={[
                            { required: true, message: "Campo requerido" }
                        ]}
                        required
                        name = {["EPagos", "ImplementadorEPagos"]}
                        label = "Implementador"
                        >                            
                            <Input />
                        </Form.Item>

                    </>
                }
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={["CotizacionUF"]}
                    label="Cotización UF">
                    <InputNumber min={1} />
                </Form.Item>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={["GastosAdministrativos"]}
                    label="Gastos administrativos (en pesos)">
                    <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"PrefijoSolicitudPago"}
                    label="Prefijo de la referencia de pago"
                >
                    <Input />
                </Form.Item>                
            </DataSave>
        </MainLayout>
    );
};
